module.exports = __webpack_public_path__ + "media/C.d48ba80e.wav";